// import react icons
import {
  FaChartBar,
  FaCheck,
  FaCheckCircle,
  FaEdit,
  FaFileImport,
  FaHistory,
  FaInfo,
  FaInfoCircle,
  FaMapMarkerAlt,
  FaUnity,
  FaUserEdit,
  FaUsers,
  FaAmazonPay,
  FaCcAmazonPay,
  FaFileArchive
} from "react-icons/fa";

import {
  MdArrowBack,
  MdOutlineEdit,
  MdCancel,
  MdAdd,
  MdPrivacyTip,
  MdEdit,
  MdDeleteOutline,
  MdCircleNotifications,
  MdKeyboardArrowRight,
  MdOutlineConfirmationNumber,
} from "react-icons/md";
import { RiDeleteBin6Line } from "react-icons/ri";
import { AiFillTag, AiOutlineUsb } from "react-icons/ai";
import { BsDot, BsFillCheckCircleFill, BsFillPrinterFill, BsBookmarksFill, BsDisplay } from "react-icons/bs";
import { AiOutlineBarcode } from "react-icons/ai";
import { IoLanguage } from "react-icons/io5";
import { TbFileInvoice, TbPrinterOff } from "react-icons/tb";
import { MdNotificationsActive } from "react-icons/md";
import { BiTransfer } from "react-icons/bi";

// material icons
import SearchIcon from "@mui/icons-material/Search";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import InventoryIcon from "@mui/icons-material/Inventory";
import SettingsIcon from "@mui/icons-material/Settings";
import BarChartIcon from "@mui/icons-material/BarChart";
import StorefrontRoundedIcon from "@mui/icons-material/StorefrontRounded";
import LogoutIcon from "@mui/icons-material/Logout";
import WifiIcon from "@mui/icons-material/Wifi";
import WifiOffIcon from "@mui/icons-material/WifiOff";
import { BookmarkAdd } from "@mui/icons-material";
import BorderAllOutlinedIcon from "@mui/icons-material/BorderAllOutlined";
import PriceChangeOutlinedIcon from "@mui/icons-material/PriceChangeOutlined";
import PrintIcon from "@mui/icons-material/Print";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import AnnouncementOutlinedIcon from "@mui/icons-material/AnnouncementOutlined";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import { BsGiftFill } from "react-icons/bs";

export const ReactIcons = {
  MdArrowBack,
  MdOutlineEdit,
  FaUserEdit,
  FaMapMarkerAlt,
  FaCheck,
  MdCancel,
  FaUsers,
  BsGiftFill,
  RiDeleteBin6Line, FaFileArchive,TbFileInvoice,
  MdAdd,
  BsDot,BsDisplay,
  MdPrivacyTip,
  MdEdit,BiTransfer, BsBookmarksFill,
  MdDeleteOutline, AiOutlineUsb, FaFileImport,
  IoLanguage, BsFillPrinterFill, TbPrinterOff, FaEdit, FaUnity, MdOutlineConfirmationNumber, MdNotificationsActive,
  FaHistory, FaChartBar, AiFillTag, MdCircleNotifications, AiOutlineBarcode, MdKeyboardArrowRight, BsFillCheckCircleFill, FaCheckCircle, FaInfo,
  FaAmazonPay,
  FaCcAmazonPay
};

export const MuiIcons = {
  SearchIcon,
  WarehouseIcon, InventoryIcon,
  SettingsIcon, WifiIcon, WifiOffIcon,
  BarChartIcon, StorefrontRoundedIcon, LogoutIcon, BookmarkAdd, BorderAllOutlinedIcon, PriceChangeOutlinedIcon, PrintIcon, SwapVertIcon, AnnouncementOutlinedIcon, GroupAddIcon, AccountBalanceWalletIcon, AccountCircleIcon, AddBusinessIcon
};
